<template>
  <div class="page__wrapper">
    <transition name="slide">
      <form v-if="!addingrep" class="repgroup__form" v-on:submit.prevent="submitRepGroup">
        <div class="form__name">Add a Rep Group</div>
        <label>Business Name</label>
        <input v-model="business_name" required type="text" placeholder="Business Name"/>
        <label>Telephone</label>
        <input v-model="phone" required type="text" placeholder="Telephone"/>
        <label>Website</label>
        <input v-model="website" type="text" placeholder="Website"/>
        <div class="actions">
          <button type="submit">Submit Rep Group</button>
          <i @click="resetForm" class="material-icons">refresh</i>
        </div>
      </form>
    </transition>
    <transition name="slide">
      <form v-if="addingrep" class="repgroup__form" v-on:submit.prevent="submitRep">
      <div class="form__name">Add a Rep 
        <div>for {{currentrep.business_name}}</div>
      </div>
      <label>First Name</label>
      <input v-model="rep_first_name" required type="text" placeholder="First Name"/>
      <label>Last Name</label>
      <input v-model="rep_last_name" required type="text" placeholder="Last Name"/>
      <label>Telephone</label>
      <input v-model="rep_phone" required type="text" placeholder="Telephone"/>
      <label>Email</label>
      <input v-model="rep_email" type="text" placeholder="Email"/>
      <label>Note</label>
      <input v-model="rep_note" type="text" placeholder="Note"/>
      <div class="actions">
        <button type="submit">Submit Rep</button>
        <i @click="resetRepForm" class="material-icons">refresh</i>
      </div>
    </form>
    </transition>
    <div class="rep__info__wrapper">
      <h3>
        <span>Groups</span>
        <i @click="addRepGroup" class="material-icons">add_circle</i>
      </h3>
      <span  
        v-for="rep in reps"
        v-bind:class="{'active': viewingrepid === rep.id, 'info__line': true}"
        v-bind:key="rep.id"
        v-bind:rep="rep"
        @click.prevent.stop="editRepGroup(rep)">
        <span>{{rep.business_name}}</span>
        <span class="actions">
          <i @click.prevent.stop="deleteRepGroup(rep.id)" class="material-icons">delete</i>
        </span>
      </span>
    </div>
    <div class="rep__info__wrapper">
      <h3>
        <span>Reps</span>
        <transition name="blip">
        <i v-if="currentrep" @click="addRep" class="material-icons">add_circle</i>
        </transition>
      </h3>
      <span class="info__line"
        v-for="rep in indireps"
        v-bind:key="rep.id"
        v-bind:rep="rep"
        @click.prevent.stop="editRep(rep)">
        <span>{{rep.first_name}} {{rep.last_name}}</span>
        <span class="actions">
          <i @click.prevent.stop="deleteRep(rep.id)" class="material-icons">delete</i>
        </span>
      </span>
    </div>
    <div class="rep__info__wrapper">
      <h3>
        <span>Factories</span>
        <transition name="blip">
        <i v-if="currentrep" class="material-icons">add_circle</i>
        </transition>
      </h3>
       <span class="info__line"
        v-for="factory in currentrep.factories"
        v-bind:key="factory"
        v-bind:factory="factory">
        <span>{{factories.find(f => f.id === factory) ? factories.find(f => f.id === factory).business_name : 'REMOVE THIS'}}</span>
         <span class="actions">
          <i @click.prevent.stop="removeRepFactory(factory)" class="material-icons">delete</i>
        </span>
      </span>
       <span class="info__line grayed"
        v-if="currentrep && (!currentrep.factories || (currentrep && !currentrep.factories.includes(factory.id)))"
        v-for="(factory, index) in factories"
        v-bind:key="factory + index"
        v-bind:factory="factory">
        <span>{{factory.business_name}}</span>
         <span class="actions">
          <i @click.prevent.stop="addRepFactory(factory.id)" class="material-icons">add</i>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import {store} from '@/store'

export default {
  name: 'RepGroups',
  data: function() {
    return {}
  },
  computed: {
    indireps: function(){
      return store.state.currentreps
    },
    currentrep: function(){
      return store.state.repgroup
    },
    addingrep: function(){
      return store.state.addingrep
    },
    factories: function(){
      return store.state.factories
    },
    reps: function(){
      return store.state.repgroups
    },
    viewingrepid: function(){
      return store.state.viewingrepid
    },
    business_name: {
      get(){ return store.state.newrepgroup.business_name },
      set(val){ store.commit('set_repgroup_business_name', val) }
    },
    phone: {
      get(){ return store.state.newrepgroup.phone },
      set(val){ store.commit('set_repgroup_phone', val) }
    },
    website: {
      get(){ return store.state.newrepgroup.website },
      set(val){ store.commit('set_repgroup_website', val) }
    },
    rep_first_name: {
      get(){ return store.state.newrep.first_name },
      set(val){ store.commit('set_rep_first_name', val) }
    },
    rep_last_name: {
      get(){ return store.state.newrep.last_name },
      set(val){ store.commit('set_rep_last_name', val) }
    },
    rep_email: {
      get(){ return store.state.newrep.email },
      set(val){ store.commit('set_rep_email', val) }
    },
    rep_phone: {
      get(){ return store.state.newrep.phone },
      set(val){ store.commit('set_rep_phone', val) }
    },
    rep_note: {
      get(){ return store.state.newrep.note },
      set(val){ store.commit('set_rep_note', val) }
    },
  },
  methods: {
    submitRepGroup: function(){
      store.dispatch('createRepGroup')
    },
    submitRep: function(){
      store.dispatch('createRep')
    },
    resetForm: function(){
      store.commit('resetrepgroupform')
    },
    resetRepForm: function(){
      store.commit('resetrepform')
    },
    editRepGroup: function(repGroup){
      store.commit('setrepgroup', repGroup)
      store.commit('setnewrepgroup', repGroup)
      store.commit('toggleaddrep', false)
      this.toggleRepView(repGroup)
    },
    toggleRepView: function(rep){
      store.commit('setrepgroup', rep)
      store.dispatch('getReps', rep.id)
      store.commit('setviewingrepid', rep.id)
      store.commit('toggleaddrep', false)
    },
    addRep: function(){
      store.commit('toggleaddrep', true)
      store.commit('resetrepform')
    },
    addRepGroup: function(){
      store.commit('resetrepgroupform')
      store.commit('toggleaddrep', false)
    },
    editRep: function(rep){
      store.commit('setnewrep', rep)
      store.commit('toggleaddrep', true)
    },
    deleteRepGroup: function(id) {
      if(confirm("Are you sure?")){
        store.dispatch('deleteRepGroup', id)
      }
    },
    deleteRep: function(id) {
      if(confirm("Are you sure?")){
        store.dispatch('deleteRep', id)
      }
    },
    addRepFactory: function(id) {
      store.dispatch('addRepFactory', id)
    },
    removeRepFactory: function(id) {
      store.dispatch('removeRepFactory', id)
    }
  }
}
</script>

<style scoped lang="less">

.page__wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
  margin-top: 60px;
  box-sizing: border-box;
  position: relative;
  height: calc(100vh - 60px);
}
.repgroup__form {
  display: block;
  width: 25%;
  background: #f4f4f4;
  padding: 24px 24px 60px 24px;
  box-sizing: border-box;
  position: static;
  top: 60px;
  left: 0px;
  bottom: 0px;
  overflow-y: auto;
  border-right: solid 1px lightgray;
  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 24px;
    button {
      padding: 12px 24px;
      color: white;
      background-color: #1882e6;
      border-radius: 3px;
      cursor: pointer;
      font-weight: bold;
      font-size: 0.9em;
    }
    i {
      padding: 12px;
      cursor: pointer;
    }
  }
  .form__name {
    font-weight: bold;
    display: block;
    font-size: 1.15em;
    background-color: inherit;
    position: sticky;
    top: 0px;
    padding: 12px 0px;
    margin-bottom: 12px;
    border-bottom: solid 1px lightgray;
    div{
      display: block;
      font-size: 12px;
      font-weight: 100;
      font-style: italic;
    }
  }
  label {
    font-size: 0.8em;
    color: #979797;
    font-weight: 100;
    text-transform: capitalize;
  }
  input {
    display: block;
    width: 100%;
    padding: 6px 0px;
    box-sizing: border-box;
    margin-bottom: 6px;
    background: transparent;
    border: none;
    border-bottom: dashed 1px lightgray;
    font-size: 0.9em;
    &:focus {
      outline: none;
      border-bottom: solid 1px;
    }
  }
}
.list__wrapper {
  display: block;
  width: 20%;
  box-sizing: border-box;
  border-right: solid 1px lightgray;
}
.rep__info__wrapper {
  display: block;
  width: 25%;
  background-color: white;
  border-right: solid 1px lightgray;
  position: relative;
  height: 100%;
  overflow-y: auto;
  h3 {
    display: block;
    background: #f4f4f4;
    width: 100%;
    padding: 12px;
    position: sticky;
    top: 0px;
    box-sizing: border-box;
    margin: 0px;
    border-bottom: solid 1px lightgray;
    z-index: 1000;
    i {
      position: absolute;
      top: 12px;
      right: 12px;
      cursor: pointer;
      color: #1882e6;
    }
  }
  .info__line {
    display: block;
    padding: 12px;
    box-sizing: border-box;
    width: 100%;
    border-bottom: dashed 1px lightgray;
    font-size: 0.9em;
    position: relative;
    cursor: pointer;
    &.active {
      background: #f4f4f4;
      font-weight: bold;
      font-style: italic;
    }
    &.grayed {
      opacity: 0.5;
      font-style: italic;
    }
    .actions {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      width: 90px;
      align-items: center;
      justify-content: flex-end;
      position: absolute;
      right: 0px;
      top: 0px;
      bottom: 0px;
      padding-right: 12px;
      i {
        font-size: 18px !important;
        cursor: pointer;
        margin-left: 6px;
      }
    }
  }
}

.header__line {
  font-weight: bold;
  position: sticky;
  top: 60px;
  background-color: white;
  .actions {
    display: none !important;
  }
}
.slide-enter-active, .slide-leave-active {
  transition: all .25s ease-out;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  position: fixed;
  transform: translateX(-250px);
  opacity: 0.5;
}
.blip-enter-active, .blip-leave-active {
  transition: all .25s ease-out;
}
.blip-enter, .blip-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scale(0);
  transform-origin: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/repgroups/RepGroups.vue